import { useState } from "react";

import type { StatusOptionType } from "src/organization/pages/project/environment/metrics/utils/polling/type";

const useLoadingOption = () => {
  return useState<StatusOptionType>({
    refresh: true,
    polling: false,
    isLoading: true,
    status: {
      type: "idle",
      isLoading: true
    }
  });
};

export default useLoadingOption;
